// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_ColumnDragTargetArea {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.CSVImporter_ColumnDragTargetArea__box {
  flex-basis: 25%;
  flex-grow: 0;
  flex-shrink: 1;
  width: 0;
  padding-top: 1em;
  padding-right: 1em;
}
.CSVImporter_ColumnDragTargetArea__boxLabel {
  margin-bottom: 0.25em;
  font-weight: bold;
  color: #202020;
  word-break: break-word;
}
.CSVImporter_ColumnDragTargetArea__boxLabel > b {
  margin-left: 0.25em;
  color: #c00000;
}
.CSVImporter_ColumnDragTargetArea__boxValue {
  position: relative;
  z-index: 0;
}
.CSVImporter_ColumnDragTargetArea__boxValueAction {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.CSVImporter_ColumnDragTargetArea__boxPlaceholderHelp {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 98%;
  padding: 0.5em;
  text-align: center;
  color: #808080;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/fields-step/ColumnDragTargetArea.scss","webpack://./theme.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;AADF;AAGE;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAIE;EACE,qBAAA;EACA,iBAAA;EACA,cCXQ;EDYR,sBAAA;AAFJ;AAII;EACE,mBAAA;EACA,cCbW;ADWjB;AAME;EACE,kBAAA;EACA,UAAA;AAJJ;AAOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AALJ;AAQE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cC3CiB;ADqCrB","sourcesContent":["@import '../../../theme.scss';\n\n.CSVImporter_ColumnDragTargetArea {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n\n  &__box {\n    flex-basis: 25%;\n    flex-grow: 0;\n    flex-shrink: 1;\n    width: 0; // avoid interference from internal width\n    padding-top: 1em; // not using margin for cleaner percentage calculation\n    padding-right: 1em;\n  }\n\n  &__boxLabel {\n    margin-bottom: 0.25em;\n    font-weight: bold;\n    color: $textColor;\n    word-break: break-word;\n\n    & > b {\n      margin-left: 0.25em;\n      color: $errorTextColor;\n    }\n  }\n\n  &__boxValue {\n    position: relative; // for action and placeholder\n    z-index: 0; // contain the z-indexes of contents (to prevent e.g. placeholder being above drag object)\n  }\n\n  &__boxValueAction {\n    position: absolute;\n    top: 0; // icon button padding matches card padding\n    right: 0;\n    z-index: 1; // right above content\n  }\n\n  &__boxPlaceholderHelp {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1; // right above content\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 98%; // nudge up a bit\n    padding: 0.5em;\n    text-align: center; // in case text wraps\n    color: $textSecondaryColor; // @todo font-size\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
